import type { ExtensionConfig } from '@goto/shell'

export const extensionConfig: ExtensionConfig = {
  id: '@ucc/gtc-cc-topic-flag',
  url: new URL('/experiences/cc-topic-flag/goto-app-extension.js', location.origin),
}

export default extensionConfig
